<template>
  <div class="career-planning bg-color-black">
    <div class="d-flex pt-2 pl-2">
      <span>
        <icon name="chart-area" class="text-icon"></icon>
      </span>
      <div class="d-flex">
        <span class="fs-xl text mx-2">职业发展规划</span>
        <dv-decoration-3 class="dv-dec-3" />
      </div>
    </div>

    <!-- 目标完成进度 -->
    <div class="progress-chart">
      <Echart
        :options="progressOptions"
        id="goalProgressChart"
        height="200px"
        width="100%"
      />
    </div>

    <!-- 职业匹配度 -->
    <div class="career-match">
      <Echart
        :options="matchOptions"
        id="careerMatchChart"
        height="200px"
        width="100%"
      />
    </div>

    <!-- 目标跟踪 -->
    <div class="goal-tracking">
      <dv-scroll-board :config="goalConfig" />
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import mockData from '@/mock/student/career_planning.json'

export default {
  data() {
    return {
      progressOptions: {},
      matchOptions: {},
      goalConfig: {
        header: ['目标', '截止日期', '进度'],
        data: [],
        rowNum: 4,
        headerHeight: 35,
        headerBGC: '#0f1325',
        oddRowBGC: '#0f1325',
        evenRowBGC: '#171c33',
        align: ['left', 'center', 'center']
      }
    }
  },
  components: {
    Echart
  },
  mounted() {
    this.initCharts()
    this.initGoalBoard()
  },
  methods: {
    initCharts() {
      // 初始化目标完成进度图
      this.progressOptions = {
        title: {
          text: '目标完成情况',
          textStyle: {
            color: '#fff',
            fontSize: 16
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '目标状态',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: mockData.progressTracking.completedGoals, 
                name: '已完成',
                itemStyle: { color: '#37a2da' }
              },
              { 
                value: mockData.progressTracking.ongoingGoals, 
                name: '进行中',
                itemStyle: { color: '#67e0e3' }
              },
              { 
                value: mockData.progressTracking.totalGoals - mockData.progressTracking.completedGoals - mockData.progressTracking.ongoingGoals, 
                name: '未开始',
                itemStyle: { color: '#e062ae' }
              }
            ]
          }
        ]
      }

      // 初始化职业匹配度图
      this.matchOptions = {
        title: {
          text: '职业匹配度分析',
          textStyle: {
            color: '#fff',
            fontSize: 16
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          max: 100,
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)'
            }
          }
        },
        yAxis: {
          type: 'category',
          data: mockData.careerRecommendations.map(item => item.career),
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
        series: [
          {
            name: '匹配度',
            type: 'bar',
            data: mockData.careerRecommendations.map(item => ({
              value: item.matchScore,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#37a2da' },
                  { offset: 1, color: '#67e0e3' }
                ])
              }
            }))
          }
        ]
      }
    },
    initGoalBoard() {
      // 处理短期目标数据
      const goalData = mockData.careerPlanning.shortTermGoals.map(goal => [
        goal.goal,
        goal.deadline,
        `${goal.progress}%`
      ])
      this.goalConfig.data = goalData
    }
  }
}
</script>

<style lang="scss" scoped>
.career-planning {
  padding: 16px;
  height: 100%;
  border-radius: 5px;

  .text {
    color: #c3cbde;
  }

  .dv-dec-3 {
    width: 100px;
    height: 20px;
  }

  .progress-chart,
  .career-match {
    margin-top: 20px;
  }

  .goal-tracking {
    margin-top: 20px;
    height: 200px;
  }
}
</style> 